/**
 * StargateV2 configuration for USDC cross-chain bridging.
 *
 * StargateV2 uses the same send()/quoteSend() interface as LayerZero OFT.
 * Ink is a "Hydra chain" in StargateV2 — free inbound bridging.
 *
 * Pool addresses verified on-chain via token() returning the correct USDC address.
 * Arbitrum pool verified: quoteSend(dstEid=30339) returns valid fee.
 */

export interface StargatePoolConfig {
  /** StargateV2 pool contract — call send()/quoteSend() here */
  poolAddress: `0x${string}`;
  /** USDC token address on this chain (for approval) */
  usdcAddress: `0x${string}`;
}

/** StargateV2 USDC pool addresses per source chain */
export const STARGATE_USDC_POOLS: Record<number, StargatePoolConfig> = {
  // Ethereum — verified on-chain: token() = 0xA0b8...eB48 (native USDC)
  // quoteSend(dstEid=30339) returns valid fee (~0.00005 ETH)
  1: {
    poolAddress: '0xc026395860Db2d07ee33e05fE50ed7bD583189C7',
    usdcAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  },
  // Arbitrum One — verified on-chain: token() = 0xaf88...5831 (native USDC)
  42161: {
    poolAddress: '0xe8CDF27AcD73a434D661C84887215F7598e7d0d3',
    usdcAddress: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
  },
};

/** Ink's LayerZero v2 Endpoint ID (destination for all bridges) */
export const INK_LZ_EID = 30339;

/**
 * Integrator fee configuration.
 * Set to 0 bps initially — increase later to monetize bridging.
 */
export const BRIDGE_FEE_CONFIG = {
  /** Fee in basis points (100 = 1%). Applied to bridged amount. */
  integratorFeeBps: 0,
};
